<template>
    <div class="row article-display">
        <h1>{{ article.title }}</h1>
        <div class="col-12 col-lg-9 article-content">
            <div class="news">
                <article>
                    <!-- <pre>{{article}}</pre> -->
                    <p class="intro">{{ article.description }}</p>
                    <p class="metadata">
                        <span>Par <i class="far fa-user"></i></span>
                        <span class="author vcard" itemprop="author" itemscope="" itemtype="http://schema.org/Person">
                            <a :href="'/auteur/' + this.article.author" itemprop="url" rel="author">
                                <span itemprop="name">{{ article.author }}</span>
                            </a>
                        </span>

                        <span v-if="article.date" class="posted-on">
                            <i class="far fa-calendar-alt"></i>
                            Posté le
                            <time :datetime="article.date">{{ dateFormat(article.date) }}</time>
                        </span>

                        <span v-if="article.updated" class="updated-on">
                            <i class="far fa-calendar-check"></i>
                            MAJ le
                            <time :datetime="article.date">{{ dateFormat(article.updated) }}</time>
                        </span>

                        <span class="readtime"> <i class="far fa-clock"></i> Lecture: {{ getReadingTime(article.readingTime) }} min </span>
                    </p>

                    <img class="article-main-image" v-lazy-load :data-src="article.img" />

                    <nuxt-content :document="article" />
                </article>
            </div>

            <div class="alert alert-info mt-5 mb-5">
                Vous avez aimé cet article ? <b>Sachez que nous soutenir ne vous coûte pas un centime</b> ! Sur Stakepool.fr, tout notre contenu est libre d'accès, sans publicité ni articles sponsorisés. Notre contenu est indépendant, et cela est
                possible grâce au <b>staking</b>. <a href="/staking">Déléguez à notre stake pool</a> pour nous soutenir dans cette démarche. Les cryptos ne quitteront pas votre portefeuille, et vous gagnerez des intérêts dessus !
            </div>
        </div>
        <div class="col-12 col-lg-3 sidebar" style="padding-top: 80px;">
            <sidebar-menu :menu="menu" :collapsed="false" :showChild="true" :showOneChild="false" :hideToggle="true" />

            <a class="social-link" href="https://discord.gg/EJYg5vmkJq">
                <img v-lazy-load data-src="/img/discord.webp" alt="discord logo" style="width: 100%" />

                <p>Envie de d'échanger avec des cryptophiles avertis ? Nous sommes sur Discord.</p>
            </a>

            <a class="social-link" href="https://twitter.com/StakepoolFR">
                <img v-lazy-load data-src="/img/twitter.webp" alt="twitter logo" style="width: 100%" />

                <p>Suivez de près l'actualité crypto qui compte en nous suivant sur Twitter.</p>
            </a>
        </div>

        <script v-html="getStructuredJSONLD()" type="application/ld+json"></script>
    </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
import moment from "moment";
import axios from "axios";
import { BPopover } from "bootstrap-vue";

import mobileDetect from "../js/mobiledetect.js";

export default {
    props: ["article", "menu"],
    components: {
        SidebarMenu
    },
    data() {
        return {
            glossary: null
        };
    },
    async mounted() {
        $(".sidebar").show();

        await this.fetchGlossary();
        this.$nextTick(() => {
            this.linkGlossary();
        });

        await this.addImagePopups();
    },
    methods: {
        async fetchGlossary() {
            // fetch the main glossary
            let response = await axios.get("/glossary/glossary.json");
            this.glossary = response.data;

            // fetch optional article categories
            let articleCategories = this.getCategories();
            if (articleCategories.length > 0) {
                console.log(articleCategories);
                for (let category of articleCategories) {
                    console.log(category);
                    let categoryGlossaryUrl = this.glossary.extend[category];
                    if (categoryGlossaryUrl !== undefined) {
                        response = await axios.get(categoryGlossaryUrl);
                        console.log(response);
                        let categoryGlossary = response.data;
                        if (this.glossary.terms && categoryGlossary.terms) {
                            this.glossary.terms = categoryGlossary.terms.concat(
                                this.glossary.terms
                            );
                        }
                    }
                }
            }
        },

        getCategories() {
            if (this.article.categories) {
                return this.article.categories
                    .split(",")
                    .map(cat => cat.trim().toLowerCase());
            } else {
                return [];
            }
        },

        linkGlossary() {
            let self = this;
            $(this.$el)
                .find('a[href$="#glossary"]')
                .each(function() {
                    console.log(
                        "linking glossary term: ",
                        $(this)[0].innerText
                    );
                    let linkText = $(this)[0].innerText;
                    let terms = self.glossary.terms;

                    for (let term of self.glossary.terms) {
                        let alternatives = term.alternatives || [];
                        alternatives.push(term.name);

                        let linkTextLC = linkText.toLowerCase();
                        let alternativesLC = alternatives.map(el =>
                            el.toLowerCase()
                        );

                        if (alternativesLC.indexOf(linkTextLC) !== -1) {
                            // Decorate this as a popover
                            //     let html = `<a class="glossary" href="${url}" title="${title}" data-toggle="popover" data-trigger="hover" data-placement="top" data-content="${def}" data-html=true>${occ.word}</a>`;
                            //     return html;
                            let url = term.link
                                ? term.link.href
                                : $(this)
                                      .attr("href")
                                      .replace("#glossary", "");
                            let alternativeText = term.alternative
                                ? " (" + term.alternatives.join(", ") + ")"
                                : "";
                            let title = term.name + alternativeText;
                            let def = term.def;

                            if (term.link) {
                                def += `<br/><br/><b>Article</b>: <b><a href="${term.link.href}">${term.link.name}</a></b>`;
                            }

                            // Now, replace our link
                            var clone = $(this)[0].cloneNode(true);

                            $(clone).attr("title", title);
                            $(clone).attr("href", url);
                            $(clone).addClass("glossary-link");
                            $(clone).attr("data-toggle", "click");
                            $(clone).attr("data-trigger", "hover");
                            $(clone).attr("data-placement", "top");
                            $(clone).attr("data-container", "body");
                            $(clone).attr("data-content", def);
                            $(clone).attr("data-html", true);

                            if (mobileDetect()) {
                                // on mobile, we want our bubble to pop on click
                                $(clone).attr("tabindex", 0);
                                $(clone).attr("data-trigger", "focus");
                                $(clone).removeAttr("href");
                            } else {
                                $(clone).attr("data-trigger", "hover");
                                $(clone).attr("href", url);
                                $(clone).click(function(e) {
                                    // close popover when link clicked (usefull for SPA)
                                    $(this).popover("hide");
                                });
                            }

                            $(this).replaceWith(clone);
                            $(clone).popover();

                            console.log(
                                "linked glossary term: ",
                                $(this)[0].innerText
                            );
                        }
                    }
                });
        },

        addImagePopups() {
            return new Promise(resolve => {
                let waitForMagnificPopup = function(cb) {
                    if ($.magnificPopup) {
                        cb();
                    } else {
                        setTimeout(waitForMagnificPopup.bind(this, cb), 50);
                    }
                };

                waitForMagnificPopup(() => {
                    $("article img").each(function() {
                        let imageLink = $("<a/>", {
                            class: "image-open"
                        }).append($(this).clone());
                        imageLink.attr("data-mfp-src", $(this).attr("src"));
                        console.log("adding src: " + $(this).attr("src"));

                        $(this).replaceWith(imageLink);
                    });

                    $(".image-open").magnificPopup({ type: "image" });
                    resolve();
                });
            });
        },

        dateFormat(unixDate) {
            return moment
                .unix(unixDate)
                .locale("fr")
                .format("ll");
        },

        dateStr(unixDate) {
            return moment.unix(unixDate).format();
        },

        getReadingTime(n) {
            let readingTime = parseInt(n / 60 / 1000);
            return readingTime >= 1 ? readingTime : 1;
        },

        getStructuredJSONLD() {
            const jsonld = {
                "@context": "http://schema.org",
                "@type": "Article",
                mainEntityOfPage: {
                    "@type": "WebPage",
                    "@id": "https://google.com/article"
                },
                headline: this.article.title,
                image: [this.article.img],
                datePublished: this.dateStr(this.article.date),
                dateModified: this.dateStr(
                    this.article.updated || this.article.date
                ),
                author: {
                    "@type": "Person",
                    name: this.article.author + " de SPFR"
                },
                publisher: {
                    "@type": "Organization",
                    name: "Stakepool.fr",
                    logo: {
                        "@type": "ImageObject",
                        url: "https://stakepool.fr/logo/logo.webp"
                    }
                }
            };

            return JSON.stringify(jsonld, null, 2);
        }
    }
};
</script>

<style>
.article-display h1 {
    font-size: 50px;
}

.nuxt-content-highlight pre {
    white-space: pre-wrap;
}

a.glossary-link {
    font-style: italic;
}

.article-display p.metadata {
    margin-bottom: 0px;
}

.article-display span.posted-on,
.article-display span.updated-on,
.article-display span.readtime {
    margin-left: 20px;
}

.article-display img.article-main-image {
    text-align: center;
    max-width: 100%;
}

.article-content table {
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.article-content td,
.article-content th {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 6px;
    padding-bottom: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.sidebar {
    display: none;
}

.sidebar .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1,
.sidebar .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-2,
.sidebar .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-3 {
    background-color: transparent !important;
}

.sidebar .v-sidebar-menu .vsm--arrow {
    display: none;
}

.article-content .icon.icon-link {
    background-image: url("/img/href.webp");
    display: inline-block;
    opacity: 0.3;
}

.article-content h2 .icon.icon-link {
    width: 30px;
    height: 30px;
    background-size: 30px 30px;
    margin-left: -30px;
    position: relative;
    top: 5px;
}

.article-content h3 .icon.icon-link {
    width: 20px;
    height: 20px;
    background-size: 20px 20px;
    margin-left: -20px;
    position: relative;
    top: 2px;
}

.article-content h4 .icon.icon-link {
    width: 15px;
    height: 15px;
    background-size: 15px 15px;
    margin-left: -15px;
    position: relative;
    top: 1px;
}

.article-content h2:hover .icon.icon-link,
.article-content h3:hover .icon.icon-link,
.article-content h4:hover .icon.icon-link {
    opacity: 1;
}

.sidebar .v-sidebar-menu {
    position: relative !important;
}

.sidebar .v-sidebar-menu .vsm--scroll-wrapper {
    height: auto;
}

.sidebar .v-sidebar-menu.vsm--expanded {
    bottom: unset !important;
}

.social-link {
    display: block;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.5);
    margin-top: 20px;
    margin-bottom: 20px;
}

.social-link p {
    font-size: 14px;
    text-align: center;
}

a.social-link:hover {
    text-decoration: none;
}

.image-open {
    cursor: zoom-in;
}

@media (max-width: 1024px) {
    .article-content h2 .icon.icon-link,
    .article-content h3 .icon.icon-link,
    .article-content h4 .icon.icon-link {
        margin-left: 0px;
    }
}
</style>
